import { ReactElement } from 'react'
import styles from '../styles/StageOptions.module.css'

interface Props {
  options: { text: string, gotoStage: number }[]
  onSelect: (stage: number) => void
}

const alphabet = "abcdefghijklmnopqrstuvwxyz".split('')

const StageOptions = ({ options, onSelect }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      {options.map((option, index) => (
        <button
          key={`option-${index}`}
          className={options.length === 1 ? styles.single : ''}
          onClick={() => onSelect(option.gotoStage)}
        >
          {options.length > 1 && <span className={styles.prefix}>{alphabet[index]}</span>}
          {option.text}
        </button>
      ))}
    </div>
  )
}

export default StageOptions
